
import { APIData } from '../constants';
import useRest from './base/useRest';

// BUSINESS

const preffix = 'businesses';
export const useBusiness = (options?: APIData) =>  useRest(`${preffix}`, options);

export const useBusinessCountryCurrency = (options?: APIData) => useRest(`${preffix}/country-currency`, options);